import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Si2tLogo from "./Si2tLogo";
import { CONTACT_EMAIL, CONTACT_PHONE_DISPLAY, CONTACT_PHONE_TEL } from "./ContactSection";
import { LegalDialog, useLegalDialog } from "../../components/LegalDialog";
import "./Footer.css";

const NAV = [
  ["Accueil", "/"],
  ["Expertises", "/#expertises"],
  ["Projets", "/#etudes"],
  ["Méthode", "/#methode"],
  ["Contact", "/#contact"],
];

const RESOURCES = [
  ["Galerie de projets", "/galerie"],
  ["Documents", "/documents"],
  ["Visualisation IA", "/visualisation"],
];

const Footer = () => {
  const legal = useLegalDialog();
  return (
  <footer className="footer" data-testid="site-footer">
    <div className="s-container">
      <div className="footer-grid">
        <div className="footer-brand">
          <Si2tLogo inverse />
          <p className="footer-meaning">Solutions d'Ingénierie Industrielle et Technique</p>
          <p className="footer-description">
            Bureau d'études externalisé pour les TPE et PME industrielles : conception mécanique, modélisation 3D,
            mise en plan et dossiers de fabrication.
          </p>
        </div>

        <nav className="footer-col" aria-label="Navigation pied de page">
          <h2 className="footer-title">Navigation</h2>
          <ul>
            {NAV.map(([label, to]) => (
              <li key={to}>
                <Link to={to}>{label}</Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav className="footer-col" aria-label="Ressources">
          <h2 className="footer-title">Ressources</h2>
          <ul>
            {RESOURCES.map(([label, to]) => (
              <li key={to}>
                <Link to={to}>{label}</Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="footer-col footer-contact">
          <h2 className="footer-title">Un besoin&nbsp;?</h2>
          <p>Présentez votre besoin : contexte, pièce concernée, fichiers disponibles.</p>
          <ul className="footer-channels" aria-label="Coordonnées">
            <li><a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-email-link">{CONTACT_EMAIL}</a></li>
            <li><a href={`tel:${CONTACT_PHONE_TEL}`} data-testid="footer-phone-link">{CONTACT_PHONE_DISPLAY}</a></li>
          </ul>
          <Link to="/#contact" className="footer-cta" data-testid="footer-cta">
            Présenter mon besoin
            <ArrowUpRight size={15} strokeWidth={2.2} />
          </Link>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} SI2T</span>
        <span className="footer-legal-links">
          <button type="button" onClick={(event) => legal.open("mentions", event)}>Mentions légales</button>
          <button type="button" onClick={(event) => legal.open("confidentialite", event)}>Confidentialité</button>
        </span>
        <span className="footer-note">
          Les projets présentés sont des exemples de livrables et des projets de démonstration, non des réalisations clients.
        </span>
      </div>
    </div>
    <LegalDialog doc={legal.doc} onClose={legal.close} returnFocusTo={legal.triggerRef} />
  </footer>
  );
};

export default Footer;
